import Attribute from "vueforms/src/xmlrdb-metadata/Attribute"

Attribute.ValidatorFunctionRegistry["MIP_MASSNAHME_FLURSTUECK.MT_ANTEILIGE_FLAECHE_M2"] = (attr) => {
  if (attr.ref.value > attr.dataElement.$.MT_FLAECHE_M2) 
     return `Anteilige Fläche (${attr.ref.value}m²) ist größer als Gesamtfläche (${attr.dataElement.$.MT_FLAECHE_M2}m²) des Flurstücks`
}